import { render, staticRenderFns } from "./cardsSlider.vue?vue&type=template&id=8efebc94&"
import script from "./cardsSlider.vue?vue&type=script&lang=js&"
export * from "./cardsSlider.vue?vue&type=script&lang=js&"
import style0 from "./cardsSlider.vue?vue&type=style&index=0&id=8efebc94&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports